export const getShareById = /* GraphQL */ `
  query GetShareById(
    $instrumentId: ID!
  )
  {
    getShare(id: $instrumentId) {
      assetClass
      close
      closeChange1D
      closeChangeAbsolute1D
      closeDate
      high
      id
      isin
      low
      latestPrice {
            price
            timestamp
            exchangeName
      }
      name
    }
  }
`

export const getEtfById = /* GraphQL */ `
  query GetEtfById(
    $instrumentId: ID!
  )
  {
    getEtf(id: $instrumentId) {
      assetClass
      close
      closeChange1D
      closeChangeAbsolute1D
      closeDate
      id
      isin
      latestPrice {
            price
            timestamp
            exchangeName
      }
      name
    }
  }
`

